// NPM
import { useState } from "react";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, CardBody } from "reactstrap";

// Calance
import styles from "Pages/Setup/TestConnection/Components/Test/Test.module.css";
import useFetch from "Hooks/useFetch";
import useAlertContext from "Hooks/useAlertContext";

interface IProps {
    system: string;
    test: string;
}

interface ITestResult {
    result: string;
}

export default function Test({ system, test }: IProps) {
    /** Causes UI changes if test results are being fetched */
    const [isTestRunning, setIsTestRunning] = useState<boolean>(false);
    const [testResults, setTestResults] = useState<string>();
    const [isFlipped, setIsFlipped] = useState<boolean>(false);

    const { post } = useFetch();
    const { newAlert } = useAlertContext();

    /** Runs a test and updates state with results */
    const runTest = async () => {
        setIsFlipped(false);
        setIsTestRunning(true);
        const url = `/api/test_connection/${system}/${test}`;

        const response = await post(url);

        let data: Response | ITestResult;
        try {
            data = await response.json();
        } catch (e) {
            data = response;
        }
        console.log("TestConnection test result response", data);

        if (response.ok) {
            setTestResults((data as ITestResult).result);
        } else {
            newAlert({ message: "Error running test" });
        }
        setIsTestRunning(false);
        setIsFlipped(true);
    };

    return (
        <div className={styles.testCardBox}>
            <div className={styles.hoverContentBox}>
                <Button
                    tag="div"
                    className={styles.hoverContent}
                    onClick={runTest}
                >
                    Run Test
                </Button>
            </div>
            <Card
                className={`${styles.testCard} ${
                    isFlipped ? styles.flipped : ""
                }`}
            >
                {/*  Front of card */}
                <CardBody className={styles.testCardBody}>
                    <b>
                        <p>{test}</p>
                    </b>
                    <br />
                    {/* Spinner */}
                    <FontAwesomeIcon
                        className={`${styles.testIcon} ${
                            isTestRunning ? "spinning" : ""
                        }`}
                        icon={faGear}
                    />
                </CardBody>
                {/* Back of card */}
                <CardBody className={`${styles.testCardBody} ${styles.back}`}>
                    <b>
                        <p>{test}</p>
                    </b>
                    <div
                        className={
                            testResults?.toLowerCase().includes("success")
                                ? `text-success ${styles.testResult}}`
                                : `text-danger ${styles.testResult}`
                        }
                    >
                        {testResults}
                    </div>
                </CardBody>
            </Card>
        </div>
    );
}
